import React from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import {userActions, walletAction } from '../../_actions';
import { userService , currencyServices } from '../../_services';

class Navbar extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            active : false 
        }

        this.toggleActive = this.toggleActive.bind(this);
        this.logoutUser = this.logoutUser.bind(this);
        this.handleDropdownHover = this.handleDropdownHover.bind(this);
    }

    logoutUser(){
        const { dispatch } = this.props;
        dispatch(userActions.logout);
    }

    toggleActive(){
        this.setState((prevState) => {
            if(prevState.active){
                return {active : false}
            }
            else {
                return {active : true}
            }
        })
    }

    handleDropdownHover(){
        //update wallet 
        const { dispatch } = this.props;

        //check auth before update wallet 
        userService.checkAuth()
        .then(response => {

            //succesful call , get wallet 
            dispatch(walletAction.getMemberWallet());
        })
        .catch(error => {

        });
    }

    componentDidMount(){

        const { dispatch } = this.props;

        dispatch(walletAction.getTicker());
        this.interval = setInterval(() => dispatch(walletAction.getTicker())  , 60*1000);
    }

    render(){
        let currentuser;
        const {wallet , ticker} = this.props ; 
        
        if(this.props.authentication){
            currentuser = this.props.authentication.user; 
        }

        return (

            <nav className="navbar is-black" role="navigation" aria-label="main navigation">
                <div className="navbar-brand">
                    <a className="logo border-right" href="/">
                        <img className="nav-logo" src="/images/logo-bright.png"/>
                    </a>
                    <a onClick={this.toggleActive} role="button" className="navbar-burger" data-target="navMenu" aria-label="menu" aria-expanded="false">
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </a>
                </div>
    
                <div id="navMenu" className={`navbar-menu ${this.state.active && `is-active`}`}>
                
                    <div className="navbar-start is-clearfix">
                        
                        {
                            (ticker.tickerinfo && ticker.tickerinfo.length > 0) && 
                            ticker.tickerinfo.map((item) => {
                                let direction = 'up'; 
                                let title = ''; 
                                
                                if(item.symbol === 'BTC' ){
                                    title = 'BTCUSD';
                                }
                                else if(item.symbol === 'ETH' ){
                                    title = 'ETHUSD';
                                }

                                if(item.percent_change_1h < 0) direction = 'down';

                                return (
                                    <div className="navbar-item price-data border-right">
            
                                        <ul>
                                            <li><h6>{title}</h6></li>
                                            <li>{Math.round(item.price_usd * 100) / 100}</li>
                                            <li>
                                                <span className={`price-fluct price-${direction}`}>
                                                <span className="icon"><i className={`fas fa-caret-${direction}`}></i></span>
                                                    {item.percent_change_1h}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            })
                        }
                        
                    </div>


                    <div className="navbar-end">
                    {
                        currentuser ? (
                            <React.Fragment>
                                <a href="/account/deposit?type=hwgcash" className="navbar-item">
                                    <button className="button is-primary non-outlined">
                                        <h6>Get HWG Cash</h6>
                                    </button>
                                </a>
                                <a href="/account/redeemhwgcash" className="navbar-item">
                                    <button className="button is-primary non-outlined">
                                        <h6>Redeem HWG Cash</h6>
                                    </button>
                                </a>
                                <div className="navbar-item has-dropdown is-hoverable" onMouseEnter={this.handleDropdownHover}>
                                    <a className="navbar-link navbar-username">
                                        {currentuser.username}
                                    </a>

                                    <div className="navbar-dropdown">
                                        <a href="/account/wallet" className="navbar-item">
                                            Wallet
                                        </a>
                                        <a href="/account/profile" className="navbar-item">
                                            My Profile
                                        </a>
                                        <hr className="navbar-divider"/>
                                        
                                        <a href="" className="navbar-item">
                                            Wallet
                                        </a>

                                        <div className="navbar-item navbar-wallet">
                                        {
                                            wallet.userwallet ? (
                                                <ul>
                                                {
                                                    wallet.userwallet.length > 0 && 
                                                    wallet.userwallet.map((wallet)=> {
                                                        return <li>{wallet.balance} {wallet.currency}</li>
                                                    })
                                                }
                                                </ul>
                                            )
                                            :
                                            (
                                                wallet.loading && 
                                                <div>Checking balance ... </div>
                                            )
                                        }
                                        </div>

                                        <hr className="navbar-divider"/>

                                        <a className="navbar-item" onClick={this.logoutUser}>
                                            Logout
                                        </a>
                                    </div>
                                </div>
                            </React.Fragment>
                        )
                        : (
                            <React.Fragment>
                                <Link to="/register" className="navbar-item">
                                    <button className="button is-primary non-outlined">
                                        <h6>Register</h6>
                                    </button>
                                </Link>
                                <Link to="/login" className="navbar-item border-right">
                                    <button className="button is-primary is-outlined">
                                        <h6>Sign In</h6>
                                    </button>
                                </Link>
                            </React.Fragment>
                        )
                    }
                    </div>
                </div>
            </nav>
        )
    }
}

function mapStateToProps(state) {
    const { authentication , wallet , ticker } = state;
    return {
        authentication , wallet , ticker
    };
}

const connectedNavbar = connect(mapStateToProps)(Navbar);
export { connectedNavbar as Navbar }; 



// WEBPACK FOOTER //
// ./src/_components/Navbar/Navbar.jsx